import { render, staticRenderFns } from "./Compte.vue?vue&type=template&id=835af65c&scoped=true&"
import script from "./Compte.vue?vue&type=script&lang=js&"
export * from "./Compte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835af65c",
  null
  
)

export default component.exports